/**
 * ScopingModeBanner - Dismissible banner for ScopeOps Scoping Mode
 * Shows at the top of the page when productMode === 'scoping-only'
 */

import React, { useState, useEffect } from 'react';
import { X, Info } from 'lucide-react';

const BANNER_DISMISSED_KEY = 'simpliview_scoping_banner_dismissed';

const ScopingModeBanner = ({ productName = "ScopeOps Scoping Mode" }) => {
  const [isDismissed, setIsDismissed] = useState(true);

  useEffect(() => {
    const dismissed = localStorage.getItem(BANNER_DISMISSED_KEY);
    setIsDismissed(dismissed === 'true');
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    localStorage.setItem(BANNER_DISMISSED_KEY, 'true');
  };

  if (isDismissed) return null;

  return (
    <div 
      className="flex items-center justify-between px-4 py-2 bg-[var(--clr-surface-card)] border-b border-[var(--clr-border-base)]"
      data-testid="scoping-mode-banner"
    >
      <div className="flex items-center gap-2">
        <Info className="w-4 h-4 text-[var(--clr-brand-primary)]" />
        <span className="text-sm font-medium text-[var(--clr-text-primary)]">
          {productName}
        </span>
        <span className="text-xs text-[var(--clr-text-secondary)]">
          — Some features are not available in this mode
        </span>
      </div>
      <button
        onClick={handleDismiss}
        className="p-1 rounded hover:bg-[var(--clr-surface-subtle)] transition-colors"
        aria-label="Dismiss banner"
        data-testid="scoping-banner-dismiss"
      >
        <X className="w-4 h-4 text-[var(--clr-text-muted)]" />
      </button>
    </div>
  );
};

export default ScopingModeBanner;
